import moment from 'moment';

const statusCategory = {
  easybank_deposit_account: 'Depositumskonto i Lea bank',
  deposit_guarantee: 'Depositumsgaranti',
  upsell_deposit_subscription: 'Depositumsgaranti fra Söderberg & Partners',
  other_deposit_guarantee: 'Depositumsgaranti',
  other_deposit_account: 'Depositumskonto',
  bank_guarantee: 'Bankgaranti',
  nav_guarantee: 'Nav-garanti',
  other: 'Annen sikkerhet',
};

const categorySupportsFunds = {
  easybank_deposit_account: true,
  deposit_guarantee: false,
  other_deposit_guarantee: false,
  other_deposit_account: true,
  bank_guarantee: false,
  nav_guarantee: false,
  other: true,
};

const statusText = {
  initial: 'Mangler innbetaling',
  pending: 'Venter',
  waiting: 'Venter',
  active: 'Alt ok',
  ended: 'Avsluttet',
  conflict: 'Kravprosess',
  createdReminder: 'Opprettet påminnelse',
  new: 'Ny',
};

const statusVariation = {
  initial: 'info',
  pending: 'warning',
  waiting: 'warning',
  active: 'primary',
  ended: 'danger',
  conflict: 'danger',
  createdReminder: 'info',
  new: 'info',
};

const statusClass = {
  initial: 'text-black',
  pending: 'text-secondary',
  waiting: 'text-secondary',
  active: 'text-success',
  ended: 'text-warning',
  conflict: 'text-success',
  createdReminder: 'text-warning',
  new: 'text-secondary',
};

const getDepositCategory = value => {
  return statusCategory[value];
};

const getDepositStatus = ({ status, category, funds = 0, amount = undefined, startDate = undefined }) => {
  if (startDate && status === 'initial' && moment().isAfter(startDate)) {
    status = 'createdReminder';
  } else if (status === 'active' && funds >= 0 && amount > 0 && funds < amount) {
    // Some deposit solutions does not support funds, so skip status change for this.
    if (categorySupportsFunds[category]) status = 'waiting';
  }

  return {
    category: statusCategory[category],
    name: statusText[status],
    variation: statusVariation[status],
    _class: statusClass[status],
    status,
  };
};

export { getDepositCategory, getDepositStatus };
